import { BaseDataService } from './BaseDataService';
import { Question, Survey } from '../../models';
import { NotificationService } from '../../services';

export class QuestionDataService extends BaseDataService<Question> {
    constructor(notificationService: NotificationService) {
        super('Question', 'Questions', notificationService);
    }

    public getAllBySurvey(survey: Survey): Promise<any> {
        const endpoint = `${this.endpointRoot}/bysurvey/${survey.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving statements.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public getAllResponsesByOrganization(questionId: number, orgId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/responses/byOrg/${questionId}/${orgId}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving statements.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public getAllResponsesByCandidates(questionId: number, orgId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/responses/byCandidates/${questionId}/${orgId}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving statements.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public getAllResponsesByFormer(questionId: number, orgId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/responses/byFormer/${questionId}/${orgId}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving statements.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public getAllResponsesByTeam(questionId: number, teamId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/responses/byTeam/${questionId}/${teamId}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving statements.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

}


// WEBPACK FOOTER //
// ./src/services/api/QuestionData.tsx